export const headerData = [
  {
    node: {
      text: "Home",
      link: "/",
      submenu: [
        {
          link: "/mantiz-platform",
          text: "Plataforma MANTIZ",
        },
      ],
      isSubmenu: true,
    },
  },
  {
    node: {
      text: "Compañía",
      link: "/#",
      submenu: [
        {
          link: "/about-us-mantiz",
          text: "¿Quiénes somos?",
        },
        {
          link: "/our-history-mantiz",
          text: "Nuestra historia",
        },
        // {
        //   link: "https://google.com",
        //   text: "Servicios Administrativos",
        // },
      ],
      isSubmenu: true,
    },
  },
  {
    node: {
      text: "Servicios",
      link: "/services",
      submenu: null,
      isSubmenu: null,
    },
  },
  {
    node: {
      text: "Procesos y soluciones",
      link: "/processes-solutions",
      submenu: null,
      isSubmenu: null,
    },
  },
  {
    node: {
      text: "Clientes",
      link: "/",
      submenu: [
        {
          link: "https://www.ol4b.com//Soporte/default.aspx",
          text: "Servicio al cliente",
        },
        // {
        //   link: "/success-stories",
        //   text: "Casos de éxito",
        // },
        // {
        //   link: "/frequent-questions",
        //   text: "Preguntas frecuentes",
        // },
      ],
      isSubmenu: true,
    },
  },
  {
    node: {
      text: "Free Trial",
      link: "/free-trial",
      submenu: null,
      isSubmenu: null,
    },
  },
//   {
 //    node: {
 //      text: "It Solutions",
 //      link: "/it-services",
 //      submenu: null,
 //      isSubmenu: null,
 //    },
//   },
]
